const merchantCategoryOpts = [
    { id: 1, value: "giardiniere", label: "Giardiniere" },
    { id: 2, value: "garden_center", label: "Garden Center" },
    { id: 3, value: "studio_progettazione", label: "Studio Progettazione" },
    { id: 4, value: "altro", label: "Altro" }
];

export default merchantCategoryOpts;